import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/pt';

import './polyfill/array-flat';
import './polyfill/array-from';
import './polyfill/object-values';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import './font-awesome/css/all.css';
import './custom-index.css';

import App from './App';

import i18n from './i18n';

import configureStore from './configureStore';
import registerServiceWorker from './registerServiceWorker';

moment.updateLocale('pt', {
  calendar : {
    lastDay : '[Ontem,] LT',
    sameDay : '[Hoje,] LT',
    nextDay : '[Amanhã,] LT',
    lastWeek : '[Último(a)] dddd[,] LT',
    nextWeek : 'dddd[,] LT',
    sameElse : 'L'
  }
});

render(
  <Provider store={configureStore()}>
    <Router>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js